import { render } from "./updatetimeitem.vue?vue&type=template&id=04d3c45c"
import script from "./updatetimeitem.vue?vue&type=script&lang=js"
export * from "./updatetimeitem.vue?vue&type=script&lang=js"

import "./updatetimeitem.vue?vue&type=style&index=0&id=04d3c45c&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__